import * as React from 'react';
import { Box, Typography, Slider, FormControlLabel, Checkbox } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';

const BarCharts = ({ rawData }) => {
    const [seriesNb, setSeriesNb] = React.useState(3);
    const [itemNb, setItemNb] = React.useState(10);
    const [skipAnimation, setSkipAnimation] = React.useState(false);

    const handleItemNbChange = (event, newValue) => {
        if (typeof newValue !== 'number') {
            return;
        }
        setItemNb(newValue);
    };

    const handleSeriesNbChange = (event, newValue) => {
        if (typeof newValue !== 'number') {
            return;
        }
        setSeriesNb(newValue);
    };

    let colors = ["#ff9100", "#eaeaea", "#0000b0"]

    /*colors = [
        "#ccebc5", "#c4e7c2", "#bde3bf", "#b5e0bc", "#addeb9", "#a5dab7", "#9ed6b4", "#96d2b1", "#8eceae", "#86caaa",
        "#7fc6a7", "#77c2a4", "#6fbfa1", "#67bb9e", "#5fb79b", "#58b398", "#50af95", "#48ab91", "#40a78e", "#38a38b",
        "#319f88", "#299b85", "#219782", "#19937e", "#118f7b", "#0a8b78", "#028775", "#007372", "#006f6e", "#006b6b"
    ]*/
    
    // Trasformazione dei dati
    const series = rawData.map((entry, index) => ({
        label: entry.name,
        data: entry.data,
        categories: entry.details, // Aggiungi le categorie qui
        color: colors[index % colors.length] // Assegna il colore dalla scala
    }));


    const categories = rawData[0].details;

    return (
        <Box sx={{ width: '100%', height: "100%", color: 'white', p: 3, justifyContent: "center", alignItems: "center" }}>
            <BarChart
                height={400}
                series={series.slice(0, seriesNb).map((s) => ({
                    ...s,
                    data: s.data.slice(0, itemNb),
                    color: s.color
                }))}
                xAxis={[
                    { 
                        scaleType: 'band', 
                        data: categories.slice(0, itemNb) 
                    }, 
                ]} // Usa le categorie qui
                skipAnimation={skipAnimation}
                borderRadius={5}
            />
            <FormControlLabel
                checked={skipAnimation}
                control={
                    <Checkbox onChange={(event) => setSkipAnimation(event.target.checked)} />
                }
                label="Skip Animation"
                labelPlacement="end"
            />
            <Typography id="input-item-number" gutterBottom>
                Number of logs
            </Typography>
            <Slider
                value={itemNb}
                onChange={handleItemNbChange}
                valueLabelDisplay="auto"
                min={1}
                max={10}
                aria-labelledby="input-item-number"
                sx={{color: "#459095"}}
            />
            <Typography id="input-series-number" gutterBottom>
                Number of days
            </Typography>
            <Slider
                value={seriesNb}
                onChange={handleSeriesNbChange}
                valueLabelDisplay="auto"
                min={1}
                max={series.length}
                aria-labelledby="input-series-number"
                sx={{color: "#459095"}}

            />
        </Box>
    );
};

export default BarCharts;